<template>
  <div id="mqttws" class="disConnected">
  </div>
</template>
<style>
#mqttws {
  height: 100px !important;
  z-index: 100000;
  position: fixed;
}
.disConnected {
  /* color: red; */
  height: 100px;
  border-radius: 50%;
  position: fixed;
  right: 0;
  z-index: 100001;
}
</style>
<script>
import { ref, computed, reactive, toRefs } from "vue";
import Paho from "./js/mqtt.js";
import { createState } from "../store";
import { useRouter } from "vue-router";
var opt;
export default {
  name: "mqttws",
  data() {
    return {
      client: {},
      options: {},
      msg: "order",
      count: 0,
      connected: false,
      commandType: "",
      deviceInfo: "",
      state: createState,
      projectTopic: this.getUrlQuery(decodeURIComponent(location.search))?.projectTopic||"",
      _beforeUnload_time: ""

    };
  },
  created() {
    console.log(this.state);
    let _this = this;
    // 获取storage里的配置参数
    this.client = new Paho.MQTT.Client(
      this.state.brokerip,
      8086,
      "WXSY_" + new Date().getTime()
    );
    this.state.client = this.client;
    var _client = this.client;
    opt = this.options = {
      timeout: 5,
      keepAliveInterval: 50,
      reconnect: true, // Enable automatic reconnect
      cleanSession: false,
      useSSL: false,
      userName: "",
      password: "",
      onSuccess: function () {
        console.log("连接成功:");
        _this.topicFun();
      },
      onFailure: function (e) {
        setTimeout(function () {
          _client.connect(opt);
        }, 5000);
      },
    };
    this.client.connect(opt); //连接服务器并注册连接成功处理事件
    this.client.onConnectionLost = this.onConnectionLost; //注册连接断开处理事件
    this.client.onMessageArrived = this.onMessageArrived; //注册消息接收处理事件
  },
  mounted() {
    window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
    window.addEventListener("unload", (e) => this.unloadHandler(e));
  },
  unmounted() {
    window.removeEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
    window.removeEventListener("unload", (e) => this.unloadHandler(e));
  },
  methods: {
    // 原生获取URL参数
    getUrlQuery(url) {
      const reg = /[?&]([^?&#]+)=([^?&#]+)/g;
      const param = {};
      let ret = reg.exec(url);
      while (ret) { // 当ret为null时表示已经匹配到最后了，直接跳出
        param[ret[1]] = ret[2];
        ret = reg.exec(url);

      }
      return param
    },
    //获取pdf
    getfileFun() {
      console.log(this.state.selectedMatchId);
      const data = {
        matchId: this.state.selectedMatchId,
      };
      this.$http
        .get("/File/GetMatchFiles?matchId=" + this.state.selectedMatchId, data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
        })
        .then((res) => {
          // console.log(res);
          if (res.status == 200 && res.data.Code == 0) {
            this.state.pdfmatchList = res.data.Result[0].MatchFileList;
            this.state.pdfprojectList = res.data.Result[0].ProjectFileList;
            this.state.pdfmatchList.map((item) => {
              if (item.FileType == 100) {
                //比赛秩序单
                item.name = "比赛秩序单";
              } else if (item.FileType == 101) {
                //比赛成绩册
                item.name = "比赛成绩册";
              }
            });
            this.state.pdfprojectList.map((item) => {
              if (item.FileType == 200) {
                //比赛成绩册
                item.name = "项目秩序单";
              } else if (item.FileType == 2001) {
                //比赛成绩册
                item.name = " 项目成绩单";
              }
            });
          } else if (res.status == 200 && res.data.Code == 204) {
            console.log("无数据");
            this.state.pdfmatchList = [];
            this.state.pdfprojectList = [];
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    topicFun() {
      const MQTT_TOPIC = this.state.matchTopic;
      this.client.subscribe(MQTT_TOPIC); //订阅监控通用指令
      this.client.subscribe(this.state.pdfListTopic); //订阅PDF文件列表
    },
    onConnectionLost: function (responseObject) {
      if (responseObject.errorCode !== 0) {
        console.log("onConnectionLost:" + responseObject.errorMessage);
        this.connected = false;
        console.log("连接已断开");
      }
    },
    onMessageArrived: function (message) {
      try {
        const list = JSON.parse(message.payloadString);
        // 将监听的PDF列表加载进来
        if (message.topic == "bowling/pdfList") {
          this.state.pdfmatchList = list.pdfmatchList;
        }
        //对监听到的数据进行处理
        //this.state.menuList 比赛列表 展示比赛名称信息
        //判断接受到的topic是否与NSSP0001/CompetitionListFlat相同
        // if (this.state.pdfmatchList.length == 0) {
          // this.getfileFun()
        // }
        if (message.topic == this.state.matchTopic) {
          // this.getfileFun()//收到NSSP0001/CompetitionListFlat消息重新请求新的pdf文件
          this.state.matchList.value = list;
          this.state.menuList.value = list.menuList;
          // this.state.showYear.value = [this.arrMatchYear()[0]];
          // 出现问题时，将下面这行代码放开试试
          // this.state.menuList.value = this.getMatchList();
          this.state.groupList.value = this.arrMatchGroup();
          this.state.active =
            this.state.active == 0 || this.state.active == undefined
              ? this.state.groupList.value[0]
              : this.state.active;
          this.state.projectList.value = this.arrMatchProject(this.state.active);
        }
        //判断收到的topic是否与请求的topic一致
        //判断是否收到 订阅的projectTopic 一致的成绩信息 收到成绩信息组织数据跳转到对应页面
        if (
          this.$route.path.indexOf("ranking") != "-1" &&
          message.topic == this.state.matchTopic
        ) {
          this.state.propshowData = this.filterliveMenuByPrjoect(
            this.state.projectInfo.groupName,
            this.state.projectInfo.matchProjectName
          );
        }
        if (message.topic == this.state.projectTopic) {
          console.log("收到订阅的项目信息");
          const dataList = JSON.parse(message.payloadString);
          //判断是否比赛结束进入到颁奖界面
          var newPath = "";
          if (dataList.projectInfo.projectScreenType == 5) {
            newPath =
              "/award" +
              `/${dataList.projectInfo.distance}${dataList.projectInfo.projectType}`;
            this.$router.push({
              path: newPath,
              query: { projectTopic: this.state.projectTopic },
            });
          } else if (list.projectInfo.projectType=='matchsheet') {
            // 跳转到对阵表页面
            this.state.mqttData = list;
            this.state.showList.value = [];
            newPath ="/bowlingmatchsheet";
            this.$router.push({
              path: newPath,
              query: { projectTopic: this.state.projectTopic },
            });
           } else {
            newPath =
              "/ranking" +
              `/${dataList.projectInfo.distance}-${dataList.projectInfo.projectType}`;
          }
          this.state.matchInfo = list.matchInfo; //保存比赛信息
          this.state.projectInfo = dataList.projectInfo; //保存项目信息
          this.matchName = list.matchInfo.matchName; //存储比赛名称
          this.state.selectedMatchId = list.matchInfo.matchID; //存储比赛id
          //展示路由名
          this.state.svgComponentName =
            "svg" + list.projectInfo.distance + list.projectInfo.gunType;
          //侧滑弹窗展示list
          this.state.propshowData = this.filterliveMenuByPrjoect(
            dataList.projectInfo.groupName,
            dataList.projectInfo.matchProjectName
          );
          //根据比赛类型进行展示数据拼接 Qualification Final
          if (!list.dataList && list.topList.length > 0) {
            this.state.showList.value = list.topList;
          } else if (!list.topList && list.dataList.length > 0) {
            this.state.showList.value = list.dataList;
          } else {
            this.state.showList.value = list.topList.concat(list.dataList);
          }
          //当前不在ranking页面跳转到ranking
          if (this.$route.path.indexOf("ranking") == "-1") {
            this.$router.push({
              path: newPath,
              query: { projectTopic: this.state.projectTopic },
            });
          } else {
          }
          if (this.state.topicType) {
            console.log("选择项目的其他阶段");
            this.$router.push({
              path: newPath,
              query: { projectTopic: this.state.projectTopic },
            });
            this.state.show = false;
            this.state.topicType = false;
          }
        }
        //根据id整理组别和项目
        if (this.state.selectedMatchId != "" && !this.state.groupList.value) {
          console.log("根据id整理组别和项目");
          this.state.groupList.value = this.arrMatchGroup();
          this.state.projectList.value = this.arrMatchProject(
            this.state.groupList.value[0]
          );
        }
        if (
          this.projectTopic !== "" &&
          !this.state.showList.value &&
          this.projectTopic !== "undefined"
        ) {

          console.log("刷新页面重新监听比赛成绩"+this.projectTopic);
          this.state.projectTopic = this.projectTopic;
          this.client.subscribe(this.state.projectTopic); //订阅监控通用指令
        }
       
        // console.log(this.state)
      } catch (error) {
        console.log(error);
      }
    },
    onConnect: function () {},
    display: function (message) {
     
    },
    // 处理select筛选后的数组
    selectedLiveMenu() {

      return this.state.matchList.value.menuList.filter((match) => {
        return match.matchId == this.state.selectedMatchId;
      });
    },
    // 根据年份获取比赛列表
    getMatchList() {
      let arr = [];
      let arrMatchId = [];
      this.state.menuList.value.forEach((item) => {
        if (arrMatchId.indexOf(item.matchId) == -1) {
          arrMatchId.push(item.matchId);
          let addArr = item;
          arr.push(addArr);
        }
      });
      // 设置默认选择项
      return arr;
    },
    // 获取所有年份
    arrMatchYear() {
      let arr = [];
      this.state.menuList.value.forEach((item) => {
        if (arr.indexOf(item.matchYear) == -1) {
          arr.push(item.matchYear);
        } else {
          return false;
        }
      });
      return arr.sort().reverse();
    },
    // 获取所有组别
    arrMatchGroup() {

      let arr = [];
      let _state = this.state;
      this.selectedLiveMenu().forEach((item) => {
        if (arr.indexOf(item.matchGroupName) == -1) {
          arr.push(item.matchGroupName);
          // 判断比赛类型，是否显示组别
          _state.championship = item.championship;
        } else {
          return false;
        }
      });
      return arr;
    },
    // 获取所有项目
    arrMatchProject(title) {
      let arr = [];
      this.filterliveMenuByGroup(title).forEach((item) => {
        let add = true;
        arr.forEach((arrItem) => {
          if (arrItem[0] == item.projectName) {
            add = false;
            return false;
          } else {
            return false;
          }
        });
        if (add) {
          arr.push([item.projectName, item.topic]);
        }
      });
      return arr;
    },
    // 2根据组别筛选比赛
    filterliveMenuByGroup(group) {
      return this.selectedLiveMenu().filter((item) => {
        return item.matchGroupName == group;
      });
    },
    // 3根据组别和项目筛选项目类别
    filterliveMenuByPrjoect(group, project) {
      return this.filterliveMenuByGroup(group)
        .filter((item) => {
          return item.projectName == project.split("(")[0]; //男子25米手枪速射(阶段2) 名称出现阶段，需过滤
        })
        .sort((a, b) => {
          const aTime = a.startTime.replace(/-/g, "/");
          const bTime = b.startTime.replace(/-/g, "/");
          if (aTime == bTime) {
            if (a.groupNo == "all") {
              return 1;
            } else {
              return -1;
            }
          }
          return (
            new Date(a.startTime.replace(/-/g, "/")) -
            new Date(b.startTime.replace(/-/g, "/"))
          );
        });
    },
    // 在页面销毁前清除mqtt连接
    beforeunloadHandler(e) {
      this._beforeUnload_time = new Date().getTime();


      //e.returnValue = '关闭提示'; 弹窗
    },
    unloadHandler(e) {
    let  _gap_time = new Date().getTime() - this._beforeUnload_time;
      //判断是窗口关闭还是刷新
      console.log(_gap_time);
      if (_gap_time <= 5) {
        console.log("xxxxxxxx");
        // 退出登录
        // xxxxxxxx
        // 通知后台
        // xxxxxxxx
      }
    },
  },
  computed: {},
};
</script>
//
<script setup>
// import { onMounted, onUnmounted } from "vue";

// let _beforeUnload_time = "";
// let _gap_time = "";

// let beforeunloadHandler = (e) => {
//   _beforeUnload_time = new Date().getTime();
//   console.log("Z1");
//   //e.returnValue = '关闭提示'; 弹窗
// };
// let unloadHandler = (e) => {
//   _gap_time = new Date().getTime() - _beforeUnload_time;
//   //判断是窗口关闭还是刷新
//   console.log("Z2");
//   if (_gap_time <= 5) {
//     console.log("xxxxxxxx");
//     // 退出登录
//     // xxxxxxxx
//     // 通知后台
//     // xxxxxxxx
//   }
// };

// onMounted(() => {
//   window.addEventListener("beforeunload", (e) => beforeunloadHandler(e));
//   window.addEventListener("unload", (e) => unloadHandler(e));
// });

// onUnmounted(() => {
//   window.removeEventListener("beforeunload", (e) => beforeunloadHandler(e));
//   window.removeEventListener("unload", (e) => unloadHandler(e));
// });
//
</script>
